import React, { useState, useEffect } from "react";
import "./DataTable.scss";
import { CiSearch } from "react-icons/ci";
import { IoMdClose } from "react-icons/io";
import Pagination from "../Pagination/Pagination";

const SubHeadersDataTable = (props) => {
  const { data, columns } = props;

  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "ascending",
  });
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(
    props.Dropdownvalues?.[0] || data?.length || 5
  );

  const sortedData = [...data].sort((a, b) => {
    if (sortConfig.key !== null) {
      const keyA =
        typeof a[sortConfig.key] === "string"
          ? a[sortConfig.key].toUpperCase()
          : a[sortConfig.key];
      const keyB =
        typeof b[sortConfig.key] === "string"
          ? b[sortConfig.key].toUpperCase()
          : b[sortConfig.key];
      return sortConfig.direction === "ascending"
        ? keyA > keyB
          ? 1
          : -1
        : keyA < keyB
        ? 1
        : -1;
    }
    return 0;
  });

  useEffect(() => {
    setCurrentPage(1);
  }, [data]);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const filteredData = sortedData.filter((row) =>
    columns.some((column) =>
      row[column.selector]
        ?.toString()
        .toLowerCase()
        .includes(searchQuery.toLowerCase())
    )
  );

  const toggleRowSelection = (rowId) => {
    if (selectedRows.includes(rowId)) {
      setSelectedRows(selectedRows.filter((id) => id !== rowId));
    } else {
      setSelectedRows([...selectedRows, rowId]);
    }
  };

  const toggleAllRows = () => {
    if (selectedRows.length === filteredData.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(filteredData);
    }
  };

  const handleRowsPerPageChange = (e) => {
    if (props.CountPage) {
      props.CountPage(e.target.value);
    }

    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(1);
  };

  const requestSort = (key, sortable) => {
    if (!sortable) return;

    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = filteredData.slice(indexOfFirstRow, indexOfLastRow);

  const renderColumnHeaders = (columns) => {
    return (
      <>
        <th rowSpan="2">S.No</th>
        {columns.map((column, index) => {
          let Subcolumnslength;
          if (column.subColumns) {
            Subcolumnslength = column.subColumns.length;
            return (
              <th key={index} colSpan={Subcolumnslength}>
                {" "}
                {column.name}{" "}
              </th>
            );
          } else {
            return (
              <th
                key={index}
                rowSpan={!column.subColumns && 2}
                style={column.sortable ? { cursor: "pointer" } : {}}
                onClick={() => requestSort(column.selector, column.sortable)}
              >
                {column.Hcell ? column.Hcell(column) : column.name}
                {column.sortable &&
                  sortConfig.key === column.selector &&
                  (sortConfig.direction === "ascending" ? " 🔽" : " 🔼")}
              </th>
            );
          }
        })}
      </>
    );
  };

  const renderSubColumnHeaders = (columns) => {
    return columns.map((column, index) => {
      if (column.subColumns) {
        return column.subColumns.map((subColumn, subIndex) => (
          <th
            key={`${index}-${subIndex}`}
            style={subColumn.sortable ? { cursor: "pointer" } : {}}
            onClick={() => requestSort(subColumn.selector, subColumn.sortable)}
          >
            {subColumn.name}
            {subColumn.sortable &&
              sortConfig.key === subColumn.selector &&
              (sortConfig.direction === "ascending" ? " 🔽" : " 🔼")}
          </th>
        ));
      }
      //  else {
      //     return <th key={index}></th>; // Empty cell for columns without sub-columns
      // }
    });
  };
  const LoadCurrentItems = (e) => {
    setCurrentPage(e);
    if (props.GetCurrentPage) {
      props.GetCurrentPage(e);
    }
    if (props.hitapi) {
      props.hitapi(e, rowsPerPage);
    }
  };
  return (
    <>
      <div className={props.className}>
        <div className="Data-Table-Filters">
          <div className="SelectRows">
            {props.ShowPagecount && (
              <>
                {" "}
                Show:
                <select
                  value={rowsPerPage}
                  onChange={handleRowsPerPageChange}
                  className="Dropdown"
                >
                  {(props.Dropdownvalues || ["5", "10", "15"])?.map(
                    (item, index) => (
                      <option key={index} value={item}>
                        {item}
                      </option>
                    )
                  )}
                </select>
              </>
            )}
          </div>
          {props.DisplaySearch && (
            <div className="Search">
              {searchQuery.length === 0 && <CiSearch />}
              <input
                type="text"
                placeholder="Search..."
                value={searchQuery}
                style={{ paddingLeft: searchQuery ? "20px" : "30px" }}
                onChange={handleSearchChange}
              />
              {searchQuery.length > 0 && (
                <IoMdClose
                  onClick={() => {
                    setSearchQuery("");
                  }}
                />
              )}
            </div>
          )}
        </div>

        <table className="Data-Table mb-2">
          <thead>
            <tr>
              {props.showCheckboxes && (
                <th>
                  <input
                    type="checkbox"
                    onChange={toggleAllRows}
                    checked={
                      selectedRows.length === filteredData.length &&
                      filteredData.length > 0
                    }
                  />
                </th>
              )}
              {renderColumnHeaders(columns)}
            </tr>
            <tr>
              {props.showCheckboxes && <th></th>}
              {renderSubColumnHeaders(columns)}
            </tr>
          </thead>
          <tbody>
            {filteredData?.length > 0 ? (
              <>
                {currentRows?.map((row, rowIndex) => (
                  <tr key={rowIndex}>
                    {props.showCheckboxes && (
                      <td>
                        <input
                          type="checkbox"
                          checked={selectedRows.includes(row)}
                          onChange={() => toggleRowSelection(row)}
                        />
                      </td>
                    )}
                    <td>
                      {props.NoPage !== "1"
                        ? (props.NoPage ? props.NoPage : currentPage) *
                            rowsPerPage -
                          rowsPerPage +
                          1 +
                          rowIndex
                        : rowIndex + 1}
                    </td>
                    {columns?.map((column, colIndex) =>
                      column.subColumns ? (
                        column.subColumns.map((subColumn, subIndex) => (
                          <td key={`${rowIndex}-${colIndex}-${subIndex}`}>
                            {subColumn.cell
                              ? subColumn.cell(row)
                              : row[subColumn.selector]}
                          </td>
                        ))
                      ) : (
                        <td key={`${rowIndex}-${colIndex}`}>
                          {column.cell
                            ? column.cell(row)
                            : row[column.selector]}
                        </td>
                      )
                    )}
                  </tr>
                ))}
              </>
            ) : (
              <tr>
                {" "}
                <td
                  colSpan={
                    columns.reduce(
                      (total, column) =>
                        total +
                        (column.subColumns ? column.subColumns.length : 1),
                      0
                    ) + 1
                  }
                  style={{ textAlign: "center" }}
                >
                  {" "}
                  *** No records Found ***{" "}
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {props.ShowPagination && (
          <Pagination
            Recorsperpage={rowsPerPage}
            currentPage={
              data.length === currentRows?.length
                ? props.NoPage || 1
                : currentPage
            }
            totalPages={Math.ceil(
              (data.length === currentRows?.length
                ? props.TotalRecords || data.length
                : filteredData?.length) / rowsPerPage
            )}
            Totalrecords={
              data.length === currentRows?.length
                ? props.TotalRecords || data.length
                : filteredData?.length
            }
            onPageChange={(e) => {
              LoadCurrentItems(e);
            }}
          />
        )}
      </div>
    </>
  );
};
export default SubHeadersDataTable;
